module.exports = __webpack_public_path__ + "static/Iki Sari Dewi-3f8fbc71d9655c12a660733f8b3b5bff.jpg";